module.exports = "/fonts/ElevanceSans-Semibold.9681f92914c93d7cf3a77e4387a7b948.woff2";